import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ './views/Authentication.vue'),
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './views/Home.vue'),
    },
    {
      path: '/quote',
      name: 'quote',
      component: () => import(/* webpackChunkName: "about" */ './views/Quote.vue'),
    },
    {
      path: '/store',
      name: 'store',
      component: () => import(/* webpackChunkName: "about" */ './views/Store.vue'),
    },
    {
      path: '/records',
      name: 'records',
      component: () => import(/* webpackChunkName: "about" */ './views/Records.vue'),
    },
    {
      path: '/corporate',
      name: 'corporate',
      component: () => import(/* webpackChunkName: "about" */ './views/Corporate.vue'),
    },
  ],
});
